module.exports = __webpack_public_path__ + "img/ssl-seal.1bc78d7c.png";